<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="header && header !== ''">{{ header }}</div>
    <div class="sopo-popup-text" *ngIf="warning && warning !== ''">{{ warning }}</div>
    <div class="sopo-popup-text" *ngIf="body && body !== ''"> {{ body }}</div>
    <span class="sopo-popup-checkbox" *ngIf="dontShowAgain !==''">
        <ion-checkbox checked="false" color="success" (ionChange)="dontShow($event)"></ion-checkbox>
        <ion-label>Don't show again</ion-label>
    </span>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close(true)">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-red-button ion-activatable clickable" (click)="close(false)">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
    <div *ngIf="verifiedLanguage" class="verified-legal-language">
        <img class="verified-logo" src="assets/verified/verified_white.webp">
        <span class="legal-language">By clicking Verify, I agree that <span (click)="openLink('https://verified.inc')" style="color: lightblue;">Verified</span> (SoPo’s service provider) and its vendors may receive my personal info and autofill more info about me, including my social security number.</span>
    </div>
</div>